import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeProvider } from 'styled-components'
import Header from '../../containers/header'
import Footer from './Footer'
import isElectron from '../../utils/isElectron'
import dark from '../../themes/dark'

const Wrapper = styled.div`
  height: 100%;
`

const Content = styled.div`
  flex-grow: 1;
  padding: 60px 0;
`

export default class Layout extends PureComponent {
  static propTypes = {
    children: PropTypes.element,
  }

  static defaultProps = {
    children: null,
  }

  render() {
    const { children } = this.props
    return (
      <Wrapper>
        {isElectron() ? (
          <Header />
        ) : (
          <ThemeProvider theme={dark}>
            <Header />
          </ThemeProvider>
        )}
        <Content>{children}</Content>
        {isElectron() ? (
          <Footer />
        ) : (
          <ThemeProvider theme={dark}>
            <Footer />
          </ThemeProvider>
        )}
      </Wrapper>
    )
  }
}
